export default "__VITE_ASSET__IY7ETSWu__"